"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LiveAudience;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _TutorialTitle = _interopRequireDefault(require("./TutorialTitle"));
var _TutorialGallery = _interopRequireDefault(require("./TutorialGallery"));
var _VideoSection = _interopRequireDefault(require("./LiveAudience/VideoSection"));
var _KnowMoreSection = _interopRequireDefault(require("./LiveAudience/KnowMoreSection"));
var _GalleryCard = _interopRequireDefault(require("./GalleryCard"));
var _AppDownloadSection = _interopRequireDefault(require("./TutorialGallery/AppDownloadSection"));
var _icInfoGrey = _interopRequireDefault(require("../../assets/images/ic-info-grey.svg"));
var _icMic = _interopRequireDefault(require("../../assets/images/ic-mic.png"));
var _icCe = _interopRequireDefault(require("../../assets/images/ic-ce.svg"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function LiveAudience() {
  const [cards, setCards] = (0, _react.useState)([]);
  const {
    t,
    i18n
  } = (0, _reactI18next.useTranslation)("lightStickTutorial");
  let isIOS = window.location.search.indexOf("platform=ios") > -1;
  const CardTwoContent = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isIOS ? /*#__PURE__*/_react.default.createElement("img", {
      src: require("../../assets/images/tutorial/liveMode/".concat((i18n === null || i18n === void 0 ? void 0 : i18n.language) || "zh", "/step2-content-ios.png")),
      style: {
        width: "100%"
      }
    }) : /*#__PURE__*/_react.default.createElement("img", {
      src: require("../../assets/images/tutorial/liveMode/".concat((i18n === null || i18n === void 0 ? void 0 : i18n.language) || "zh", "/step2-content.png")),
      style: {
        width: "100%"
      }
    }), /*#__PURE__*/_react.default.createElement(StyledToolTipContainer, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        marginTop: "20px",
        fontSize: "15px"
      }
    }, t("gallery.moreMethod"), /*#__PURE__*/_react.default.createElement("img", {
      style: {
        marginLeft: "12px"
      },
      width: 27,
      src: _icInfoGrey.default
    })), /*#__PURE__*/_react.default.createElement(StyledToolTipText, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      t: t,
      i18nKey: "gallery.moreMethodDescription",
      components: [/*#__PURE__*/_react.default.createElement("img", {
        style: {
          verticalAlign: "middle",
          margin: "0 5px"
        },
        width: 35,
        src: _icMic.default
      })]
    }))));
  };
  (0, _react.useEffect)(() => {
    if (i18n !== null && i18n !== void 0 && i18n.language) {
      const galleryCards = [];
      galleryCards.push( /*#__PURE__*/_react.default.createElement(_GalleryCard.default, {
        index: 1
      }, /*#__PURE__*/_react.default.createElement(_AppDownloadSection.default, {
        i18n: i18n
      })));
      galleryCards.push( /*#__PURE__*/_react.default.createElement(_GalleryCard.default, {
        index: 2
      }, /*#__PURE__*/_react.default.createElement(CardTwoContent, null)));
      for (let i = 3; i <= 8; i++) {
        galleryCards.push( /*#__PURE__*/_react.default.createElement(StyledImg, {
          src: require("../../assets/images/tutorial/liveMode/".concat((i18n === null || i18n === void 0 ? void 0 : i18n.language) || "zh", "/").concat(i, ".png"))
        }));
      }
      setCards(galleryCards);
    }
  }, [i18n]);
  return /*#__PURE__*/_react.default.createElement(MainContainer, null, /*#__PURE__*/_react.default.createElement(_TutorialTitle.default, {
    title: t("liveAudience.mainTitle"),
    subTitle: t("liveAudience.subTitle")
  }), /*#__PURE__*/_react.default.createElement(StyledTutorialGallery, {
    cards: cards
  }), /*#__PURE__*/_react.default.createElement(_VideoSection.default, null), /*#__PURE__*/_react.default.createElement(_KnowMoreSection.default, null), /*#__PURE__*/_react.default.createElement(StyledCeSection, null, /*#__PURE__*/_react.default.createElement(StyledIcon, {
    src: _icCe.default
  }), t("ceClaim")));
}
const MainContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  padding: 60px 0 100px 0;\n\n  @media (min-width: 768px) {\n    padding: 80px 0 120px 0;\n  }\n"])));
const StyledImg = _styledComponents.default.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 300px;\n\n  @media (min-width: 768px) {\n    width: 360px;\n  }\n"])));
const StyledToolTipText = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  visibility: hidden;\n  border-radius: 6.589px;\n  border: 1.318px solid rgba(255, 255, 255, 0.5);\n  background: #282828;\n  color: #fff;\n  text-align: center;\n  padding: 20px 25px;\n  border-radius: 6px;\n  display: inline-block;\n  text-align: left;\n  font-size: 18px;\n  width: 250px;\n  font-family: Roboto;\n\n  bottom: 100%;\n  left: 20%;\n\n  /* Position the tooltip text - see examples below! */\n  position: absolute;\n  z-index: 1;\n"])));
const StyledToolTipContainer = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  color: #a7a7a7;\n\n  &:hover ", " {\n    visibility: visible;\n  }\n"])), StyledToolTipText);
const StyledTutorialGallery = (0, _styledComponents.default)(_TutorialGallery.default)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-top: 20px;\n  @media (min-width: 768px) {\n    margin-top: 40px;\n  }\n"])));
const StyledCeSection = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-top: 30px;\n  padding: 0 24px;\n\n  font-size: 15px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n\n  opacity: 0.8;\n\n  @media (min-width: 768px) {\n    font-size: 16px;\n    margin-top: 40px;\n  }\n"])));
const StyledIcon = _styledComponents.default.img(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 30px;\n  margin-right: 8px;\n\n  @media (min-width: 768px) {\n    width: 36px;\n    margin-right: 12px;\n  }\n"])));